export { BaseIcon } from './BaseIcon';
